"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const lightingContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kelebihan Sewa Lighting Terdekat untuk Acara & Produksi Konten</h2>

    <h3 className="text-lg font-semibold mb-2">
      Sewa Lighting Terdekat: Panggung Lebih Hidup, Konten Lebih Cinematic
    </h3>

    <p className="mb-4">
      Mau bikin acara meriah atau hasil video makin pro? Gak perlu beli mahal, cukup <strong>sewa lighting terdekat</strong>.
      Tersedia lighting untuk panggung, event indoor/outdoor, hingga lighting studio untuk kebutuhan foto & video shoot.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Lighting Panggung & Studio Siap Pakai</h4>
        <p className="text-sm">
          Kami punya banyak pilihan: par LED, moving head, laser, smoke, dan strobe untuk <strong>lighting panggung</strong>,
          serta softbox, ring light, dan RGB panel untuk <strong>lighting studio</strong>. Semua bisa kamu <strong>sewa dari lokasi terdekat</strong>.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Paket Sewa Lighting Terdekat Bisa Custom</h4>
        <p className="text-sm">
          Gak perlu bingung teknis. Mau lighting buat wedding outdoor, konser mini, podcast, atau video produk?
          Tim kami siap bantu pilihkan paket lighting yang sesuai, bisa request jumlah, jenis, dan efek khusus.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Gratis Setup & Teknisi untuk Area Terdekat</h4>
        <p className="text-sm">
          Untuk wilayah <strong>sewa lighting terdekat</strong>, kami sediakan teknisi setting + uji coba lighting langsung di lokasi.
          Termasuk instalasi DMX controller, mapping efek, dan sinkronisasi dengan musik/acara.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Support Event Harian & Produksi Rutin</h4>
        <p className="text-sm">
          Mau event 1 hari atau lighting studio mingguan untuk syuting konten? Semua bisa.
          Kami siap support dari sewa harian hingga paket langganan bulanan buat production house atau content creator.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Sewa Lighting Terdekat Terjangkau</h4>
        <p className="text-sm">
          Biaya sewa fleksibel, tergantung kebutuhan. Kamu bisa ambil paket hemat untuk lighting basic,
          atau full set buat efek megah. Semua <strong>harga sewa lighting terdekat</strong> dijamin transparan & bisa nego.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Lighting Event Indoor & Outdoor</h2>
    <p className="mb-4">
      Dari ballroom, lapangan, rooftop, sampai panggung café, kami sudah berpengalaman handle berbagai venue.
      <strong>Sewa lighting terdekat</strong> bikin kamu gak pusing logistik & setting rumit.
    </p>

    <h2 className="text-xl font-bold mb-3">Lighting Studio Siap Produksi Konten Profesional</h2>
    <p className="mb-4">
      Soft light? RGB vibe? Dramatic shadow? Semua tersedia.
      <strong>Lighting studio</strong> kami cocok untuk podcast, YouTube, TikTok, produk, dan kebutuhan profesional lainnya.
      Bisa include tripod, boom arm, dan backdrop sesuai request.
    </p>

    <h2 className="text-xl font-bold mb-3">Bisa Booking Cepat & Mendadak</h2>
    <p className="mb-4">
      Kebutuhan lighting dadakan buat event besok atau syuting sore ini? Selama unit ready,
      <strong>sewa lighting terdekat</strong> bisa langsung dikirim hari yang sama. Fast response, fast setup.
    </p>

    <CTA
      title="Siap Bersinar Menyala Bosku?"
      description="🚚 Butuh sewa lighting terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Lighting Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20lighting.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Lighting"
    />
  </>
);
